module.exports = __webpack_public_path__ + "assets/images/bellingenGolfcluba7bf7249.png";